export const GRID_COL_NUM = {
    extraSmall: 5,
    small: 4,
    large: 3,
    extraLarge: 2
};

export const GRID_OPTIONS = {
    extraSmall: 'extraSmall',
    small: 'small',
    large: 'large',
    extraLarge: 'extraLarge'
};
